import { QuestionCircleOutlined } from '@ant-design/icons'
import { Form, Input, Modal, Popover, Select } from 'antd'

import { AppAdmin } from 'api/app-admin'
import { stakingPoolTypeOptions, statusOptions, StatusStakingNFTEnum } from 'constants/staking-nft'
import { isValidETHAddress } from 'utils/validate-fields'

const ModalStakingNft = ({
  form,
  isModalOpen,
  modalMode,
  setIsModalOpen,
  messageApi,
  afterOnSuccess,
}: any) => {
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 14 },
    },
  }

  const handleOk = () => {
    form
      .validateFields()
      .then(async (values: any) => {
        if (modalMode === 'update') {
          const { key: _, id, status, ...dataEdit } = values

          const response = await AppAdmin.stakingTokenizeUpdate(id, {
            ...dataEdit,
            isActive: status === StatusStakingNFTEnum.ENABLE,
          })
          if (afterOnSuccess) {
            await afterOnSuccess(response)
          }
        } else {
          const { key: _, status, ...createData } = values
          const response = await AppAdmin.stakingTokenizeCreate({
            ...createData,
            isActive: status === StatusStakingNFTEnum.ENABLE,
          })
          if (afterOnSuccess) {
            await afterOnSuccess(response)
          }
        }
      })
      .catch((error: any) => {
        messageApi.open({
          type: 'error',
          content: error.message ? error.message : error.errorFields[0].errors[0],
        })

        if (error && error.message) {
          form.setFields([
            {
              name: error.message.split(' ')[0],
              errors: [error.message],
            },
          ])
        }
      })
  }

  const handleCancel = () => {
    setIsModalOpen(false)

    form.resetFields()
  }

  return (
    <Modal
      title={modalMode === 'update' ? 'Update Staking NFT' : 'Create Staking NFT'}
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      className="modalStaking"
      destroyOnClose={true}
      width={750}
      centered
      okText={modalMode === 'update' ? 'Save' : 'Create'}
    >
      <Form form={form} {...formItemLayout} style={{ maxWidth: 750 }}>
        {modalMode === 'update' ? (
          <Form.Item
            label={
              <span>
                Pool ID
                <Popover
                  content={
                    <>
                      <p>The ID of the pool is used to identify the pool in the database.</p>
                      <p>Pool Id cannot be changed</p>
                    </>
                  }
                  placement="top"
                  title="Explain"
                >
                  <span style={{ marginLeft: 5 }}>
                    <QuestionCircleOutlined />
                  </span>
                </Popover>
              </span>
            }
            name="id"
          >
            <Input disabled />
          </Form.Item>
        ) : null}

        <Form.Item
          label={
            <span>
              Pool Type
              <Popover
                content={
                  <>
                    <p>The name of the pool is displayed on the web.</p>
                    <p>
                      Users are not allowed to enter special characters and must not exceed 30
                      characters
                    </p>
                  </>
                }
                placement="top"
                title="Explain"
              >
                <span style={{ marginLeft: 5 }}>
                  <QuestionCircleOutlined />
                </span>
              </Popover>
            </span>
          }
          name="name"
          rules={[
            { required: true, message: 'Please input Pool Name!' },
            {
              validator(_, value) {
                if (!value) {
                  return Promise.reject()
                }

                if (value.length > 30) {
                  return Promise.reject(new Error('Input must not exceed 30 characters.'))
                }

                if (/^[a-zA-Z0-9\s-]+$/.test(value)) {
                  return Promise.resolve()
                } else {
                  return Promise.reject(new Error('Pool Name cannot contain special characters!'))
                }
              },
            },
          ]}
        >
          <Select placeholder="Enter Pool Type" options={stakingPoolTypeOptions} />
        </Form.Item>

        <Form.Item
          label={
            <span>
              Pool Contract Address
              <Popover
                content={
                  <p>The contract address of the pool. This is used to get the pool information.</p>
                }
                placement="top"
                title="Explain"
              >
                <span style={{ marginLeft: 5 }}>
                  <QuestionCircleOutlined />
                </span>
              </Popover>
            </span>
          }
          style={{ marginBottom: 0 }}
          required={true}
        >
          <div className="pool-contract">
            <Form.Item
              name="contractAddress"
              rules={[
                {
                  required: true,
                  message: 'Please input Pool Contract!',
                },
                {
                  validator(_, value) {
                    if (!value) {
                      return Promise.resolve()
                    }
                    if (isValidETHAddress(value) === false) {
                      return Promise.reject('Invalid Pool Contract')
                    }
                    return Promise.resolve()
                  },
                },
              ]}
              style={{ width: '100%' }}
            >
              <Input placeholder="Enter Pool Contract" />
            </Form.Item>
          </div>
        </Form.Item>

        <Form.Item
          label={
            <span>
              Pool Status
              <Popover
                content={
                  <div>
                    <p>Enable: The Pool is active and shows on the web.</p>
                    <p>Disable: The Pool is not active and does not show on web.</p>
                  </div>
                }
                placement="top"
                title="Explain"
              >
                <span style={{ marginLeft: 5 }}>
                  <QuestionCircleOutlined />
                </span>
              </Popover>
            </span>
          }
          name="status"
          rules={[{ required: true, message: 'Please input Status!' }]}
        >
          <Select placeholder="Choose Status" options={statusOptions} />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default ModalStakingNft
